<template>
  <div>
    <a-button :loading="loading" type="primary" danger @click="showDialog"> 丢单 </a-button>

    <a-modal :confirmLoading="loading" v-model:visible="visible" title="丢单记录 " @ok="handleOk">
      <a-form layout="vertical">
        <a-form-item label="丢单原因" v-bind="validateInfos.projectDiscardReason">
          <dict-select
            v-model:value="formRef.projectDiscardReason"
            code="throwSingle_reason"
          ></dict-select>
        </a-form-item>
        <a-form-item label="丢单备注" v-bind="validateInfos.remark">
          <a-textarea
            show-count
            v-model:value="formRef.remark"
            placeholder="请输入说明，最多200字"
            :auto-size="{ minRows: 3 }"
            :maxlength="200"
            allowClear
          />
        </a-form-item>
        <div class="mt15">注：标记丢单后将不可发起立项审批，请谨慎操作</div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from "vue";
import { Form } from "ant-design-vue";
import { ProfileService } from "../../profile.service";
import { message } from "ant-design-vue";
import { getCurrentTenantId } from "@/utils";
import { useFlowEmitter } from "@/utils/emitter";
const formRules = {
  projectDiscardReason: [{ required: true, message: "请选择丢单原因" }],
  remark: [{ required: false }],
};
export default defineComponent({
  name: "lost-order-btn",
  components: {},
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const { emitEvent } = useFlowEmitter();
    const state = reactive({
      visible: false,
      formRef: {
        projectDiscardReason: undefined,
        remark: "",
      },
    });

    const showDialog = () => {
      resetFields();
      state.visible = true;
    };
    const { run, loading } = ProfileService.useThrowSingleApi();
    const handleOk = async () => {
      try {
        await validate();
        emit("update:loading", true);
        const { bizId } = props;
        const data = {
          tenantId: getCurrentTenantId(),
          projectId: bizId,
          ...state.formRef,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          message.error(res.respDesc);
          return;
        }
        emitEvent(bizId);
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
      } finally {
        emit("update:loading", false);
      }
    };
    const { resetFields, validate, validateInfos } = Form.useForm(state.formRef, formRules);
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
      loading,
      validateInfos,
    };
  },
});
</script>

<style scoped>
.approval-dialog__subtitle {
  color: #6d6d6d;
  position: absolute;
  top: 16px;
  left: 128px;
  font-size: 14px;
}
</style>
